import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import {
  Button,
  Container,
  Dimmer,
  Grid,
  Label,
  Loader,
  Menu,
} from 'semantic-ui-react';
import qs from 'qs';
import { TRANSLATION_FILES, namespaces } from '../../../constants/translation';
import NavBar from '../../../components/NavBar';
import PageNav from '../../../components/PageNav';
import { fetchM } from '../../../actions/fetchM';
import { decodeSearch, encodeSearch } from '../../../utils/url';
import isbase64 from '../../../utils/isbase64';
import { getItem, setItem } from '../../../utils/storage';
import config from '../../../../config';
import UnitReservationRefunds from './UnitReservationRefunds';
import { flashErrorMessage } from '../../../actions/flash';

const tabs = [
  { id: 1, name: 'pending', text: 'Pending' },
  { id: 2, name: 'approved', text: 'Completed' },
  { id: 3, name: 'declined', text: 'Declined' },
];

class Manage extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }

  static propTypes = {
    appConfig: PropTypes.shape({}),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    loading: PropTypes.bool,
  }

  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })

  static getPropsToState = (props) => {
    const token = '';
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const advanceFilter = false;
    const projectFilter = (isbase64(query.projectFilter) && qs.parse(atob(query.projectFilter)).name) || '';
    return {
      token,
      currentPage,
      search,
      advanceFilter,
      projectFilter,
      loadingSearch: false,
      findProjectResults: [],
      noResultsMessage: 'Loading...',
    };
  }
  constructor(props) {
    super(props);
    const localAutoReloadValue = getItem(`${config.get('appName')}.bookingManageAutoReload`);
    const isAutoReloadOn = localAutoReloadValue === 'true';
    const state = Manage.getPropsToState(props);
    const query = decodeSearch(props.location.search);
    const hasProjectFilter = !!(query.projectFilter && query.projectFilter.length > 0);
    this.state = {
      ...state,
      advanceFilter: hasProjectFilter,
      autoReload: isAutoReloadOn,
      count: 0,
      currentTabID: 1,
      data: [],
      limit: 0,
      loading: true,
      offset: 0,
      pendingCount: 0,
      approvedCount: 0,
      declinedCount: 0,
    };
    this._isMounted = false;
  }
  componentDidMount() {
    this._isMounted = true;
    this.fetchHeaderCounts();
    if (this.state.autoReload) {
      this.setRefreshDataTimeout();
    }
  }
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search || nextProps.loading !== this.props.loading) {
      const state = Manage.getPropsToState(nextProps);
      const query = decodeSearch(nextProps.location.search);
      const activeTab = tabs.find(t => t.name === query.status);

      state.currentTabID = activeTab ? activeTab.id : 1;
      state.loading = nextProps.loading;

      this.setState({ ...state });
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }
    if (this.timeoutRefresh) {
      clearTimeout(this.timeoutRefresh);
    }
  }
  setLoadingSearch(loadingSearch = false) {
    return new Promise((res) => {
      this.setState({ loadingSearch }, res);
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  setRefreshDataTimeout = () => {
    if (this.timeoutRefresh) {
      clearTimeout(this.timeoutRefresh);
    }
    this.timeoutRefresh = setTimeout(() => {
      this.handleRefreshData();
      this.setRefreshDataTimeout();
    }, 30000); // 30 seconds auto refresh time
  }
  handleChangePage = (page) => {
    const query = decodeSearch(this.props.location.search);
    query.page = page;

    this.setState({ currentPage: page });

    this.pushQuery(query);
  }
  handleChangeTab = (e, { value }) => {
    e.preventDefault();
    this.setState({
      currentTabID: value,
    }, () => {
      this.handleChangePage(1);
    });
  }

  fetchHeaderCounts = async (search = '') => {
    const { store } = this.context;
    const statuses = ['pending', 'approved', 'declined'];
    const searchQuery = search ? `&${qs.stringify({ search })}` : '';

    try {
      const requests = statuses.map(status =>
        store.dispatch(fetchM(`/unit_reservation_refunds/?status=${status}${searchQuery}`, {
          method: 'GET',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
        }))
      );

      const responses = await Promise.all(requests);

      if (!this._isMounted) return;

      const getHeaderCount = (res) => {
        if (res && res.ok) {
          const count = res.headers.get('m-data-count');
          return count ? parseInt(count, 10) : 0;
        }
        return 0;
      };

      const p = getHeaderCount(responses[0]);
      const a = getHeaderCount(responses[1]);
      const d = getHeaderCount(responses[2]);

      this.setState({
        pendingCount: p,
        approvedCount: a,
        declinedCount: d,
      });
    } catch (e) {
      if (this._isMounted) {
        // eslint-disable-next-line no-console
        console.error('Header count fetch failed', e);
      }
    }
  }

  handleExportData = async () => {
    const { store } = this.context;
    const query = decodeSearch(this.props.location.search);

    try {
      await this.setLoading(true);

      const res = await store.dispatch(
        fetchM(
          `/unit_reservation_refunds/export/?${encodeSearch(query)}`,
          {
            method: 'GET',
            credentials: 'include',
          },
        ),
      );

      if (!res.ok) {
        const errorText = await res.text();

        store.dispatch(
          flashErrorMessage({
            message: errorText || `Export failed (${res.status})`,
          }),
        );

        return;
      }

      // Convert response into blob
      const blob = await res.blob();
      const disposition = res.headers.get('Content-Disposition');
      let filename = 'download.csv';

      if (disposition && disposition.includes('filename=')) {
        filename = disposition
          .split('filename=')[1]
          .replace(/"/g, '');
      }

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = filename;

      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Header count fetch failed', err);
      store.dispatch(
        flashErrorMessage({
          message: err || 'Export failed',
        }),
      );
    } finally {
      await this.setLoading(false);
    }
  };

  handleRefreshData = () => {
    const { store } = this.context;
    const query = decodeSearch(this.props.location.search);

    query.page = 1;

    const statusMap = { 1: 'pending', 2: 'approved', 3: 'declined' };
    query.status = statusMap[this.state.currentTabID] || 'pending';

    this.props.fetchRefunds(query);
    this.fetchHeaderCounts(query.search || '');
    store.dispatch(replace(`/opportunities/manage_refunds/?${encodeSearch(query)}`));
  }
  handleAutoReload = () => {
    const autoReload = !this.state.autoReload;
    this.setState({ autoReload }, () => {
      setItem(`${config.get('appName')}.bookingManageAutoReload`, autoReload ? 'true' : 'false');
      // if autoReload is disabled when there is an ongoing timeout then..
      // ..clear the timeout also.
      if (autoReload) {
        this.handleRefreshData();
        this.setRefreshDataTimeout();
      } else {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        if (this.timeoutRefresh) {
          clearTimeout(this.timeoutRefresh);
        }
      }
    });
  }
  replaceQuery(q, resetPage = false) {
    const { store } = this.context;
    const { currentTabID } = this.state;

    const activeTab = tabs.find(t => t.id === currentTabID);

    const query = {
      ...q,
      page: resetPage ? 1 : (q.page || 1),
      status: activeTab ? activeTab.name : 'pending',
    };

    store.dispatch(replace(`/opportunities/manage_refunds/?${encodeSearch(query)}`));
    this.props.fetchRefunds(query);
  }
  pushQuery(q) {
    const { store } = this.context;
    const { currentTabID } = this.state;
    const activeTab = tabs.find(t => t.id === currentTabID);

    const query = {
      ...q,
      status: activeTab ? activeTab.name : 'pending',
    };

    store.dispatch(replace(`/opportunities/manage_refunds/?${encodeSearch(query)}`));
    this.props.fetchRefunds(query);
  }

  renderMenuTool = () => {
    const {
      autoReload,
    } = this.state;
    const { loading, t } = this.props;
    return (
      <Grid.Row className="toolbar">
        <Grid.Column>
          <Grid verticalAlign="middle">
            {/* List Data */}
            <Grid.Row className="app--listdata">
              <Grid.Column>
                <br className="large-hide" />
                <Dimmer style={{ zIndex: 20 }} active={loading} inverted>
                  <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                </Dimmer>
                <Grid>
                  <Grid.Row>
                    <Grid.Column textAlign="center" width={16}>
                      <Button
                        onClick={this.handleAutoReload}
                        compact
                        size="tiny"
                        icon={autoReload ? { name: 'toggle on', color: 'green' } : { name: 'toggle off', color: 'red' }}
                        content={`${t('Auto Refresh')} ${autoReload ? t('On') : t('Off')}`}
                      />
                      <Button
                        color="blue"
                        onClick={this.handleRefreshData}
                        compact
                        size="tiny"
                        icon="refresh"
                        content={t('Refresh Now')}
                      />
                      <Button
                        color="blue"
                        onClick={this.handleExportData}
                        compact
                        size="tiny"
                        icon="download"
                        content={t('Export')}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>
    );
  }

  render() {
    const {
      currentPage,
      currentTabID,
      pendingCount,
      approvedCount,
      declinedCount,
    } = this.state;
    const totalCount = pendingCount + approvedCount + declinedCount;
    const { refundData, refundCount, refundLimit, refundOffset, refundToken, loading, t } = this.props;
    return (
      <Container>
        <NavBar
          // Simplify header: if no data, just show 'Manage', otherwise show total
          header={!totalCount ? t('Manage') : <span>{t('Manage')} &nbsp;<Label color="blue">{totalCount}</Label></span>}
        />

        {this.renderMenuTool()}

        <Grid verticalAlign="middle" className="booking-list">
          <Grid.Row className="tab-menu manage-booking-tab">
            <Grid.Column width={16}>
              <Menu attached="top" tabular>
                {tabs.map((tab) => {
                  let countToDisplay = 0;
                  if (tab.id === 1) countToDisplay = pendingCount;
                  if (tab.id === 2) countToDisplay = approvedCount;
                  if (tab.id === 3) countToDisplay = declinedCount;
                  return (
                    <Menu.Item
                      key={tab.id}
                      value={tab.id}
                      onClick={this.handleChangeTab}
                      active={currentTabID === tab.id}
                    >
                      <span>
                        {t(tab.text)}&nbsp;
                        <Label color="blue">{countToDisplay || 0}</Label>
                      </span>
                    </Menu.Item>
                  );
                })}
              </Menu>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={16}>
              <UnitReservationRefunds
                auth={this.props.auth}
                data={refundData || []}
                loading={loading}
                refundToken={refundToken}
                fetchRefund={this.props.fetchRefunds}
                onUpdateOpportunity={this.props.onUpdateOpportunity}
                fetchHeaderCounts={this.fetchHeaderCounts}
                pendingCancelUnitsTab={currentTabID !== 1}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column textAlign="center">
              <PageNav
                currentPage={currentPage}
                count={refundCount}
                limit={refundLimit}
                offset={refundOffset}
                dataSize={(refundData || []).length}
                loading={loading}
                onChange={this.handleChangePage}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}
export default withTranslation(namespaces)(withRouter(connect(Manage.mapStateToProps)(Manage)));



// WEBPACK FOOTER //
// ./src/containers/Opportunities/ManageRefunds/Manage.jsx